export const FEATURE_FLAG_EXPERIMENT_COOKIE_NAME = "x-flag-exp"
export const FEATURE_FLAG_INTERNAL_COOKIE_NAME = "x-flag-internal"

export const flags = {
  FLAG_FEAT_ANNUAL_SURVEY: "membership-annual-survey-link",
  FLAG_FEAT_APPLICATIONS_MEMBERSHIP: "applications-membership",
  FLAG_FEAT_CAREER_PROFILE_DASHBOARD: "pga-career-profile-dashboard",
  FLAG_FEAT_MEMBER_APPLICATION_CHECKLIST:
    "account-member-application-checklist",
}
